import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import 'rsuite/dist/rsuite.min.css';
import './CustomCheckTreeHome.css';

import { Add, Minus } from 'iconsax-react';
import HeaderFilter from '../FilterList/Filters/NewFilterList/components/HeaderFilter/HeaderFilter';

export const CustomCheckTreeHome = ({
  filters,
  filtersProps,
  filterReference,
  updateSelectedFilters,
  isHome,
  clear,
  queryForFilterHome,
  setEntitiesCheckoutDefault,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [filteredData, setFilteredData] = useState(filters[0]['options']);
  const [isCheckeds, setIsCheckeds] = useState([]);
  const [labelsOpen, setLabelsOpen] = useState([]);
  const [isDefault, setIsDefault] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [search, setSearch] = useState('');
  const [someValue, setNewValue] = useState(null);
  const [trigger, setTrigger] = useState(false);

  const url = new URL(window.location.href);
  const location = useLocation();

  useEffect(() => {
    setIsCollapsed(false);
  }, [location.pathname]);

  const getUrlParameters = () => {
    const url = new URL(window.location.href);
    const params = {};
    url.searchParams.forEach((value, key) => {
      try {
        if (key === 'fields' || key === 'filters' || key === 'entity') {
          try {
            params[key] = JSON.parse(decodeURIComponent(value));
          } catch {
            params[key] = JSON.parse(value);
            console.log('Quatum computing failed at filters'); // EXPLANATION: Solução paleativa
          }
        } else {
          try {
            params[key] = decodeURIComponent(value);
          } catch {
            params[key] = value;
            console.log('Quatum computing failed'); // EXPLANATION: Solução paleativa
          }
        }
      } catch (e) {
        params[key] = decodeURIComponent(value);
      }
    });
    setIsCheckeds(
      params.filters?.entity || params.filters?.entities || filters[0].default,
    );
    const storedFilters = JSON.parse(localStorage.getItem('filters')) || {};
    storedFilters.entities = params.filters?.entity;
    localStorage.setItem('filters', JSON.stringify(storedFilters));
    return params;
  };

  const getItemLevel = (item, level = 1) => {
    if (!item.parent) return level;
    return getItemLevel(item.parent, level + 1);
  };

  function extractLabelsWithChildren() {
    let result = [];
    filters[0]['options'][0] &&
      filters[0]['options'][0].children.map((item) => {
        if (item.children && item.children.length > 0) {
          result.push(item.label);
          item.children.map((item2) => {
            if (item2.children && item2.children.length > 0) {
              result.push(item2.label);
            }
          });
        }
      });

    setLabelsOpen([
      'Tribunais Superiores',
      'Justiça Federal',
      'Justiça Estadual',
      'Órgãos Administrativos',
      'Federais',
      'Estaduais',
      'Justiça do Trabalho',
    ]); // EXPLANATION: Esse filtro executar aqui faz com que ele entre aberto nos resultados
    return result; // EXPLANATION: Eu retorno esse cara e uso o setLAbelOpenbs apenas para o botão de maximizar
  }

  useEffect(() => {
    extractLabelsWithChildren();
  }, [filters]);

  useEffect(() => {
    getUrlParameters();
  }, []);

  useEffect(() => {
    const params = {};
    url.searchParams.forEach((value, key) => {
      try {
        if (key === 'fields' || key === 'filters' || key === 'entity') {
          try {
            params[key] = JSON.parse(decodeURIComponent(value));
          } catch {
            params[key] = JSON.parse(value);
            console.log('Quantum computing failed', key);
          }
        } else {
          try {
            params[key] = decodeURIComponent(value);
          } catch {
            params[key] = value;
            console.log('Quantum computing failed', key);
          }
        }
      } catch (e) {
        params[key] = decodeURIComponent(value);
      }
    });

    if (params.filters?.entity) {
      setIsCheckeds(params.filters?.entity);
    }
  }, [url]);

  const filterTreeData = (data, searchValue) => {
    if (!searchValue) return data;

    const lowerSearch = searchValue.toLowerCase();

    return data
      .map((item) => {
        if (item.children) {
          const filteredChildren = filterTreeData(item.children, searchValue);

          if (
            filteredChildren.length > 0 ||
            item.label.toLowerCase().includes(lowerSearch)
          ) {
            return { ...item, children: filteredChildren };
          }
        }

        return item.label.toLowerCase().includes(lowerSearch)
          ? { ...item }
          : null;
      })
      .filter(Boolean);
  };

  useEffect(() => {
    if (labelsOpen.length > 0) {
      setIsCollapsed(true);
    } else {
      setIsCollapsed(false);
    }
  }, [labelsOpen]);

  const updateUrlWithSelectedEntities = (selected) => {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);

    const storedFilters = JSON.parse(localStorage.getItem('filters')) || {};
    storedFilters.entities = selected;
    localStorage.setItem('filters', JSON.stringify(storedFilters));

    params.set('filters', JSON.stringify(storedFilters));
    const queryParams = decodeURIComponent(params.toString());
    if (window.location.pathname == '/pesquisa/resultados') {
      window.history.replaceState({}, '', `${url.pathname}?${queryParams}`);
    }
  };

  const updateLocalStorageFilters = (selectedEntities) => {
    const storedFilters = JSON.parse(localStorage.getItem('filters')) || {};
    storedFilters.entities = selectedEntities;
    localStorage.setItem('filters', JSON.stringify(storedFilters));
  };

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  const changeEntityCheckbox = (item) => {
    setIsCheckeds((prevItems) => {
      if (item.children) {
        const childrenValues = item.value;

        const estaChecked = checkArrayStatus(childrenValues, prevItems);

        if (estaChecked === true) {
          return prevItems.filter((value) => !childrenValues.includes(value));
        }

        return [...new Set([...prevItems, ...childrenValues])];
      }

      if (prevItems.includes(item.value)) {
        return prevItems.filter((value) => value !== item.value);
      } else {
        return [...prevItems, item.value];
      }
    });
  };

  useEffect(() => {
    filtersProps.setTmpFilters(filterReference, isCheckeds);
    updateSelectedFilters({ [filterReference]: isCheckeds });
    updateLocalStorageFilters(isCheckeds);
    updateUrlWithSelectedEntities(isCheckeds);

    if (setEntitiesCheckoutDefault) setEntitiesCheckoutDefault(isCheckeds);
    if (isDefault) {
      localStorage.setItem('filtroSelecionado', JSON.stringify(isCheckeds));
    }
  }, [isCheckeds]);

  const checkArrayStatus = (subsetArray, mainArray) => {
    if (mainArray.length === 0) {
      return false;
    }

    if (!Array.isArray(subsetArray) || subsetArray.length === 0) {
      return 'Subset array inválido ou vazio';
    }

    if (!Array.isArray(mainArray) || mainArray.length === 0) {
      return 'Main array inválido ou vazio';
    }

    const allPresent = subsetArray.every((item) => mainArray.includes(item));
    const nonePresent = subsetArray.every((item) => !mainArray.includes(item));

    if (allPresent) {
      return true;
    } else if (nonePresent) {
      return false;
    } else {
      return 'Alguns';
    }
  };

  useEffect(() => {
    if (clear) {
      const allOptions = [];

      const collectOptions = (items) => {
        items.forEach((item) => {
          if (item.value && item.value.length > 0) {
            allOptions.push(item.value);
          }
          if (item.children && item.children.length > 0) {
            collectOptions(item.children);
          }
        });
      };

      collectOptions(filters[0]?.options || []);

      const uniqueOptions = [...new Set(allOptions.flat())];

      setIsCheckeds(uniqueOptions);
    }
  }, [clear, filters]);

  const handleDefaultToggle = () => {
    const newValue = !isDefault;
    setIsDefault(newValue);

    localStorage.setItem('isDefaultFiltro', newValue.toString());

    if (newValue) {
      localStorage.setItem('filtroSelecionado', JSON.stringify(isCheckeds));
    }
  };

  useEffect(() => {
    const saved = localStorage.getItem('filtroSelecionado');
    const isDefaultSaved = localStorage.getItem('isDefaultFiltro');

    if (saved && isDefaultSaved === 'true') {
      const filtrosSalvos = JSON.parse(saved);
      setIsCheckeds(filtrosSalvos);
      setIsDefault(true);
    }
  }, []);

  const handleSelectAllGroups = (group) => {
    const groupValues = [];

    const collectValues = (items) => {
      items.forEach((item) => {
        if (item.value) {
          if (Array.isArray(item.value)) {
            groupValues.push(...item.value);
          } else {
            groupValues.push(item.value);
          }
        }
        if (item.children && item.children.length > 0) {
          collectValues(item.children);
        }
      });
    };

    if (group.value) {
      if (Array.isArray(group.value)) {
        groupValues.push(...group.value);
      } else {
        groupValues.push(group.value);
      }
    }

    collectValues(group.children || []);

    setIsCheckeds((prev) => [...new Set([...prev, ...groupValues])]);
  };

  const handleRemoveAllGroups = () => {
    setIsCheckeds([]);
  };

  const openModalSalvarFiltro = () => {
    setModalType('salvarFiltro');
    setIsOpenModal(true);
  };

  const openModalMeusFiltros = () => {
    setModalType('meusFiltros');
    setIsOpenModal(true);
  };

  const CloseModal = () => {
    setIsOpenModal(false);
    setModalType(null);
  };

  const handleStateUpdate = (updatedState) => {
    console.log('Estado atualizado do HeaderFilter:', updatedState);
  };

  const isGroupFullySelected = (group) => {
    const groupValues = [];

    const collectValues = (items) => {
      items.forEach((item) => {
        if (item.value) {
          if (Array.isArray(item.value)) {
            groupValues.push(...item.value);
          } else {
            groupValues.push(item.value);
          }
        }
        if (item.children && item.children.length > 0) {
          collectValues(item.children);
        }
      });
    };

    if (group.value) {
      if (Array.isArray(group.value)) {
        groupValues.push(...group.value);
      } else {
        groupValues.push(group.value);
      }
    }

    collectValues(group.children || []);
    return groupValues.every((val) => isCheckeds.includes(val));
  };

  const handleRemoveGroupValues = (group) => {
    const groupValues = [];

    const collectValues = (items) => {
      items.forEach((item) => {
        if (item.value) {
          if (Array.isArray(item.value)) {
            groupValues.push(...item.value);
          } else {
            groupValues.push(item.value);
          }
        }
        if (item.children && item.children.length > 0) {
          collectValues(item.children);
        }
      });
    };

    if (group.value) {
      if (Array.isArray(group.value)) {
        groupValues.push(...group.value);
      } else {
        groupValues.push(group.value);
      }
    }

    collectValues(group.children || []);

    setIsCheckeds((prev) => prev.filter((item) => !groupValues.includes(item)));
  };

  return (
    <div className="home-tv-select_collapsable">
      <div className="home-tv-select_collapsable-header">
        <span className="home-title-filter">
          <div
            style={{
              display: 'flex',
              gap: '10px',
            }}
          >
            Selecione os órgãos
            <div className="left-link">
              <button onClick={openModalSalvarFiltro}>Salvar filtro</button>
              <span> - </span>
              <button onClick={openModalMeusFiltros}>Meus filtros</button>
            </div>
          </div>
        </span>

        <div className="button-container">
          <button
            onClick={(e) => {
              handleSelectAllGroups(filteredData[0]);
              e.preventDefault();
            }}
            className="select-all-home-filter"
          >
            <Add size="12" color="#0D91FE" /> Selecionar todos
          </button>
          <button
            onClick={(e) => {
              handleRemoveAllGroups();
              e.preventDefault();
            }}
            className="remove-all"
          >
            <Minus size="12" color="#475467" /> Remover todos
          </button>
        </div>
      </div>
      <hr className="full-width" />
      <div className="btn-select">
        <span
          style={{
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
          }}
        >
          Seleção rápida
        </span>

        <span
          className="btn-select-all"
          onClick={(e) => {
            e.preventDefault();
            isGroupFullySelected(filteredData[0])
              ? handleRemoveGroupValues(filteredData[0])
              : handleSelectAllGroups(filteredData[0]);
          }}
        >
          {isGroupFullySelected(filteredData[0])
            ? 'Remover todos'
            : 'Selecionar todos'}
        </span>
      </div>

      <div
        style={{
          display: 'flex',
          gap: '6px',
          flexWrap: 'wrap',
        }}
      >
        {filteredData[0].children.map((group, index) => {
          const list = group.children;
          const mockName = [
            'Superiores',
            'Justiça Federal',
            'Justiça Estadual',
            '',
            'Trabalhistas',
          ];
          const mockOrgaos = ['Adm. Federais', 'Adm. Estaduais'];

          if (group.label !== 'Órgãos Administrativos') {
            return (
              <div
                key={`group-${index}`}
                className={`home-content-checkbox-children-flat ${
                  checkArrayStatus(group.value, isCheckeds) === 'Alguns'
                    ? 'indeterminate-bg'
                    : (
                          group.children
                            ? checkArrayStatus(group.value, isCheckeds) !== true
                            : !isCheckeds?.includes(group.value)
                        )
                      ? 'not-selected'
                      : ''
                }`}
              >
                <input
                  type="checkbox"
                  onClick={(e) => changeEntityCheckbox(group)}
                  id="scales"
                  name="scales"
                  readOnly
                  checked={
                    group.children
                      ? checkArrayStatus(group.value, isCheckeds) === true
                      : isCheckeds?.includes(group.value)
                  }
                  ref={(el) => {
                    if (el) {
                      el.indeterminate =
                        checkArrayStatus(group.value, isCheckeds) === 'Alguns';
                    }
                  }}
                />
                {mockName[index]}
              </div>
            );
          } else {
            return (
              <div
                style={{
                  display: 'flex',
                  gap: '6px',
                }}
                key={`admin-${index}`}
              >
                {list.map((child, childIndex) => (
                  <div
                    key={`group-${index}`}
                    className={`home-content-checkbox-children-flat ${
                      checkArrayStatus(child.value, isCheckeds) === 'Alguns'
                        ? 'indeterminate-bg'
                        : (
                              group.children
                                ? checkArrayStatus(child.value, isCheckeds) !==
                                  true
                                : !isCheckeds?.includes(group.value)
                            )
                          ? 'not-selected'
                          : ''
                    }`}
                  >
                    <input
                      type="checkbox"
                      onClick={(e) => changeEntityCheckbox(child)}
                      id="scales"
                      name="scales"
                      readOnly
                      checked={
                        child.children
                          ? checkArrayStatus(child.value, isCheckeds) === true
                          : isCheckeds?.includes(child.value)
                      }
                      ref={(el) => {
                        if (el) {
                          el.indeterminate =
                            checkArrayStatus(child.value, isCheckeds) ===
                            'Alguns';
                        }
                      }}
                    />
                    {mockOrgaos[childIndex]}
                  </div>
                ))}
              </div>
            );
          }
        })}
      </div>
      <hr className="full-width" />
      <div className="home-content-filters">
        {filteredData[0] &&
          filteredData[0].children.map((group) => {
            const list = group.children;

            return (
              <div className="home-filter-group-box" key={group.label}>
                <div className="home-content-checkbox">
                  <div className="home-box-content-two">
                    <span className="home-group-title">{group.label}</span>
                  </div>
                  <span
                    className="btn-select-all"
                    onClick={() =>
                      isGroupFullySelected(group)
                        ? handleRemoveGroupValues(group)
                        : handleSelectAllGroups(group)
                    }
                  >
                    {isGroupFullySelected(group)
                      ? 'Remover todos'
                      : 'Selecionar todos'}
                  </span>
                </div>

                <div
                  className={`${
                    group.label === 'Justiça Estadual' ||
                    group.label === 'Órgãos Administrativos'
                      ? ''
                      : 'home-group-checkbox-container-horizontal'
                  }`}
                >
                  {group.label === 'Tribunais Superiores'
                    ? list.flatMap((sub) => {
                        if (sub.children?.length) {
                          return sub.children.map((child) => (
                            <div
                              className={`home-content-checkbox-children-flat ${
                                (
                                  child.children
                                    ? checkArrayStatus(
                                        child.value,
                                        isCheckeds,
                                      ) !== true
                                    : !isCheckeds?.includes(child.value)
                                )
                                  ? 'not-selected'
                                  : ''
                              }`}
                              key={child.value}
                            >
                              <input
                                type="checkbox"
                                onClick={() => changeEntityCheckbox(child)}
                                readOnly
                                checked={
                                  child.children
                                    ? checkArrayStatus(
                                        child.value,
                                        isCheckeds,
                                      ) === true
                                    : isCheckeds?.includes(child.value)
                                }
                              />
                              {child.label}
                            </div>
                          ));
                        }

                        return (
                          <div
                            className={`home-content-checkbox-children-flat ${
                              (
                                sub.children
                                  ? checkArrayStatus(sub.value, isCheckeds) !==
                                    true
                                  : !isCheckeds?.includes(sub.value)
                              )
                                ? 'not-selected'
                                : ''
                            }`}
                            key={sub.value}
                          >
                            <input
                              type="checkbox"
                              onClick={() => changeEntityCheckbox(sub)}
                              readOnly
                              checked={
                                sub.children
                                  ? checkArrayStatus(sub.value, isCheckeds) ===
                                    true
                                  : isCheckeds?.includes(sub.value)
                              }
                            />
                            {sub.label}
                          </div>
                        );
                      })
                    : group.label === 'Justiça Estadual' ||
                        group.label === 'Órgãos Administrativos'
                      ? list.map((sub) => (
                          <div
                            className={`home-column-checkbox-group ${
                              (
                                sub.children
                                  ? checkArrayStatus(sub.value, isCheckeds) !==
                                    true
                                  : !isCheckeds?.includes(sub.value)
                              )
                                ? 'not-selected'
                                : ''
                            }`}
                            key={sub.value}
                          >
                            <div className="home-subgroup-title">
                              {sub.label}
                            </div>
                            <div className="home-row-checkboxes">
                              {(sub.children || []).map((child) => (
                                <div
                                  className={`home-content-checkbox-children-flat ${
                                    (
                                      child.children
                                        ? checkArrayStatus(
                                            child.value,
                                            isCheckeds,
                                          ) !== true
                                        : !isCheckeds?.includes(child.value)
                                    )
                                      ? 'not-selected'
                                      : ''
                                  }`}
                                  key={child.value}
                                >
                                  <input
                                    type="checkbox"
                                    className="home-input"
                                    onClick={() => changeEntityCheckbox(child)}
                                    readOnly
                                    checked={isCheckeds.includes(child.value)}
                                  />
                                  {child.label}
                                </div>
                              ))}
                            </div>
                          </div>
                        ))
                      : list.map((sub) => {
                          const subList = sub.children;
                          return (
                            <div
                              className={`home-content-checkbox-children ${
                                (
                                  sub.children
                                    ? checkArrayStatus(
                                        sub.value,
                                        isCheckeds,
                                      ) !== true
                                    : !isCheckeds?.includes(sub.value)
                                )
                                  ? 'not-selected'
                                  : ''
                              }`}
                              key={sub.value}
                            >
                              <input
                                type="checkbox"
                                className="home-input"
                                onClick={() => changeEntityCheckbox(sub)}
                                readOnly
                                checked={isCheckeds.includes(sub.value)}
                                ref={(el) => {
                                  if (el && sub.children) {
                                    const status = checkArrayStatus(
                                      sub.children.map((child) => child.value),
                                      isCheckeds,
                                    );
                                    el.indeterminate = status === 'Alguns';
                                  }
                                }}
                              />
                              {sub.label}
                              {subList?.map((finalItem) => (
                                <div
                                  className={`home-content-checkbox-children-two ${
                                    (
                                      finalItem.children
                                        ? checkArrayStatus(
                                            finalItem.value,
                                            isCheckeds,
                                          ) !== true
                                        : !isCheckeds?.includes(finalItem.value)
                                    )
                                      ? 'not-selected'
                                      : ''
                                  }`}
                                  key={finalItem.value}
                                >
                                  <div className="home-content-children">
                                    <div>
                                      <input
                                        type="checkbox"
                                        className="home-input"
                                        onClick={() =>
                                          changeEntityCheckbox(finalItem)
                                        }
                                        readOnly
                                        checked={isCheckeds.includes(
                                          finalItem.value,
                                        )}
                                      />
                                      {finalItem.label}
                                    </div>
                                    <span className="home-entity-count-two">
                                      {isHome
                                        ? filtersProps.entities_counter[
                                            finalItem.value
                                          ] || 0
                                        : 0}
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          );
                        })}
                </div>
              </div>
            );
          })}
      </div>
      <hr className="full-width" />
      <div className="footer-filter-options">
        <div className="right-toggle">
          <span>Usar essa configuração como padrão</span>
          <label className="switch">
            <input
              type="checkbox"
              checked={isDefault}
              onChange={handleDefaultToggle}
            />
            <span className="slider"></span>
          </label>
        </div>
      </div>

      {isOpenModal && (
        <HeaderFilter
          CloseModal={CloseModal}
          isCarregarFiltros={modalType === 'meusFiltros'}
          updateSelectedFilters={updateSelectedFilters}
          search={search}
          filtersProps={filtersProps}
          setNewValue={setNewValue}
          handleStateUpdate={handleStateUpdate}
          trigger={trigger}
          setTrigger={setTrigger}
          queryForFilterHome={queryForFilterHome}
          setIsCheckeds={setIsCheckeds}
          filterInHome={true}
        />
      )}
    </div>
  );
};
